class CartRemoveButton2 extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-notification").updateQuantity(this.dataset.index, 0);
      this.closest(".cart-notification-product").classList.add("loading");
      this.closest(
        ".cart-notification-product"
      ).firstElementChild.classList.remove("hidden");
    });
  }
}
customElements.define("cart-remove-button-2", CartRemoveButton2);

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = this;
    this.cartItemConatiner = this.querySelector("#cart-notification-product");

    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );

    this.querySelector(
      'button[type="button"].cart-notification__close'
    ).addEventListener("click", this.close.bind(this));

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));

    this.initUpsellSlider();

    // Initialize shipping calculation
    if (window.cartShippingFee) {
      this.config = JSON.parse(JSON.stringify(window.cartShippingFee));
      const countryCode = (this.config.localizationCountry || 'nl').toLowerCase();
      this.config.countryCode = countryCode;
      this.config.countryData = this.findCountryLine(countryCode);
      this.calculateShippingFee();
      this.updateFreeShippingBar();
    }
  }

  findCountryLine(countryCode) {
    if (!this.config.allCountries) return null;
    const lines = this.config.allCountries.split('\n');
    for (const line of lines) {
      const trimmed = line.trim();
      if (!trimmed) continue;
      const parts = trimmed.split('|');
      if (parts[0].trim().toLowerCase() === countryCode) {
        return {
          shippingFee: parseInt(parts[1]) || 0,
          freeShippingThreshold: parseInt(parts[2]) || 0,
        };
      }
    }
    return null;
  }

  calculateShippingFee() {
    if (!this.config || !this.config.countryData) {
      const el = document.querySelector('[data-cart-shipping-costs]');
      if (el) el.innerHTML = this.config?.checkoutLabel || 'Berekend bij afrekenen';
      return;
    }

    const subtotalElement = document.querySelector('[data-subtotal]');
    if (!subtotalElement) return;

    const shippingFeeElement = document.querySelector('[data-cart-shipping-costs]');
    const totalPriceElement = document.querySelector('[data-cart-total-price]');
    if (!shippingFeeElement || !totalPriceElement) return;

    // data-subtotal and all_countries amounts are both in local currency cents — no conversion needed
    const subtotalCents = parseInt(subtotalElement.dataset.subtotal);
    const { shippingFee, freeShippingThreshold } = this.config.countryData;

    const activeCurrency = window.Shopify?.currency?.active || 'EUR';
    const locale = window.Shopify?.locale || 'en';

    const effectiveShipping = (freeShippingThreshold && subtotalCents >= freeShippingThreshold) ? 0 : shippingFee;
    const totalCents = subtotalCents + effectiveShipping;

    if (effectiveShipping === 0) {
      shippingFeeElement.innerHTML = this.config.freeLabel || 'Free';
    } else {
      shippingFeeElement.innerHTML = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: activeCurrency,
      }).format(effectiveShipping / 100);
    }

    totalPriceElement.innerHTML = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: activeCurrency,
    }).format(totalCents / 100);
  }

  updateFreeShippingBar() {
    if (!this.config || !this.config.countryData) return;

    const bar = document.getElementById('cart-free-shipping-bar');
    const messageEl = document.getElementById('cart-free-shipping-message');
    const progressEl = document.getElementById('cart-free-shipping-progress');
    if (!bar || !messageEl || !progressEl) return;

    const subtotalElement = document.querySelector('[data-subtotal]');
    if (!subtotalElement) return;

    // data-subtotal and all_countries thresholds are both in local currency cents — no conversion needed
    const subtotalCents = parseInt(subtotalElement.dataset.subtotal);
    const { freeShippingThreshold } = this.config.countryData;

    if (!freeShippingThreshold) {
      bar.style.display = 'none';
      return;
    }

    bar.style.display = 'block';

    const locale = window.Shopify?.locale || 'en';
    const activeCurrency = window.Shopify?.currency?.active || 'EUR';
    const percent = Math.min((subtotalCents / freeShippingThreshold) * 100, 100);

    progressEl.style.width = this._progressPercent || '0%';
    void progressEl.offsetWidth; // force reflow so CSS transition has two distinct states
    progressEl.style.width = percent + '%';
    this._progressPercent = percent + '%';

    if (subtotalCents >= freeShippingThreshold) {
      messageEl.innerHTML = this.config.freeShippingText || "You've unlocked free shipping!";
      bar.classList.add('cart-free-shipping-bar--unlocked');
    } else {
      const amountLeft = freeShippingThreshold - subtotalCents;
      const formattedAmount = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: activeCurrency,
      }).format(amountLeft / 100);
      const template = this.config.shippingThresholdText || "You're {amount} away from free shipping!";
      messageEl.innerHTML = template.replace('{amount}', `<strong>${formattedAmount}</strong>`);
      bar.classList.remove('cart-free-shipping-bar--unlocked');
    }
  }

  initUpsellSlider() {
    const cartItems = document.getElementById('min-cart-items');
    const track = this.querySelector('.cart-upsell__track');
    if (!track) {
      if (cartItems) cartItems.classList.add('no-upsells');
      return;
    }
    if (cartItems) cartItems.classList.remove('no-upsells');

    const slides = track.querySelectorAll('.cart-upsell__slide');
    const prevBtn = this.querySelector('.cart-upsell__nav--prev');
    const nextBtn = this.querySelector('.cart-upsell__nav--next');

    const wrapper = track.closest('.cart-upsell__wrapper');
    if (slides.length > 1) {
      if (wrapper) wrapper.classList.add('has-multiple-slides');
    } else {
      if (wrapper) wrapper.classList.remove('has-multiple-slides');
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
    }

    let currentIndex = 0;

    const goTo = (index) => {
      currentIndex = Math.max(0, Math.min(index, slides.length - 1));
      track.scrollTo({ left: currentIndex * track.offsetWidth, behavior: 'smooth' });
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex === slides.length - 1;
    };

    if (prevBtn) prevBtn.addEventListener('click', () => goTo(currentIndex - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(currentIndex + 1));

    track.addEventListener('scroll', () => {
      const index = Math.round(track.scrollLeft / track.offsetWidth);
      if (index !== currentIndex) {
        currentIndex = index;
        if (prevBtn) prevBtn.disabled = currentIndex === 0;
        if (nextBtn) nextBtn.disabled = currentIndex === slides.length - 1;
      }
    }, { passive: true });

    goTo(0);

    this.querySelectorAll('.cart-upsell__add').forEach((btn) => {
      btn.addEventListener('click', () => {
        const variantId = btn.dataset.variantId;
        btn.classList.add('loading');
        btn.disabled = true;

        const body = JSON.stringify({
          id: parseInt(variantId),
          quantity: 1,
          sections: this.getSectionsToRender().map((s) => s.id),
          sections_url: window.location.pathname,
        });

        fetch(routes.cart_add_url, { ...fetchConfig(), ...{ body } })
          .then((r) => r.json())
          .then((state) => {
            if (state.sections) {
              this.renderContents(state);
            }
            // /cart/add.json only returns the added item, not the full cart.
            // Fetch the full cart so tiered pricing gets the correct item count.
            return fetch(`${routes.cart_url}.json`);
          })
          .then((r) => r.json())
          .then((fullCart) => {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-upsell',
              cartData: fullCart,
            });
          })
          .catch(() => {
            btn.classList.remove('loading');
            btn.disabled = false;
          });
      });
    });
  }

  onChange(event) {
    if (event.target.closest("quantity-input")) {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute("name"),
        event.target.dataset.quantityVariantId
      );
    }
  }

  open() {
    this.notification.classList.add("animate", "active");
    document.querySelector("body").classList.add("added__overlay");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    this.notification.classList.remove("active");
    document.querySelector("body").classList.remove("added__overlay");
    document.body.removeEventListener("click", this.onBodyClick);

    //removeTrapFocus(document.querySelector(".header__actions_btn--cart"));
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace = document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id]
      );
    });

    if (this.header) this.header.reveal();
    this.open();

    // Recalculate shipping after cart updates
    if (this.config) {
      this.calculateShippingFee();
      this.updateFreeShippingBar();
    }

    this.initUpsellSlider();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification",
      },
      {
        id: "cart-notification-count",
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    const body = JSON.stringify({
      line: parseInt(line, 10),
      quantity: parseInt(quantity, 10),
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    document
      .querySelector(".cart_action_drawer_overlay")
      .classList.add("active");
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`);
        const items = document.querySelectorAll(".cart-notification-product");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.renderContents(parsedState);

        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-notification",
          cartData: parsedState,
          variantId: variantId,
        });
      })
      .catch(() => {})
      .finally(() => {
        document
          .querySelector(".cart_action_drawer_overlay")
          .classList.remove("active");
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`);
    if (lineItemError) {
      lineItemError.classList.remove("d-none");
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;
    }
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target !== this.notification &&
      !target.closest("cart-notification") &&
      !target.closest("#quickViewWrapper")
    ) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);

class OpenMiniCart extends HTMLElement {
  constructor() {
    super();

    this.cartButton = this.querySelector("a");

    this.cartButton.addEventListener("click", (event) => {
      event.preventDefault();
      this.onClickMiniCart();
    });

    this.notification = document.getElementById("offcanvas__mini_cart");
    this.onBodyClassRemove = this.handleBodyClass.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.miniCartClose()
    );
  }

  onClickMiniCart() {
    document
      .getElementById("offcanvas__mini_cart")
      .classList.add("animate", "active");
    document.querySelector("body").classList.add("added__overlay");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClassRemove);
  }

  miniCartClose() {
    document.getElementById("offcanvas__mini_cart").classList.remove("active");
    document.querySelector("body").classList.remove("added__overlay");

    document.body.removeEventListener("click", this.onBodyClassRemove);
  }

  handleBodyClass(evt) {
    let eventTarget = evt.target;
    if (
      !eventTarget.closest("cart-notification") &&
      !eventTarget.closest("open-minicart") &&
      !eventTarget.closest("button")
    ) {
      this.miniCartClose();
    }
  }
}
customElements.define("open-minicart", OpenMiniCart);
